import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const OrganizationSEO: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Remove any existing organization structured data
    const existingScript = document.querySelector('script[data-organization-structured-data="true"]');
    if (existingScript) {
      existingScript.remove();
    }

    const isZh = i18n.language === 'zh';

    // Create organization structured data
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Resonow",
      "alternateName": isZh ? "共振疗愈平台" : "Resonow Healing Platform",
      "description": isZh 
        ? "Resonow是一个专业的疗愈师平台，提供能量疗愈、心理咨询、传统中医等多种疗愈服务。"
        : "Resonow is a professional healing platform offering energy healing, psychological counseling, traditional Chinese medicine, and various healing services.",
      "url": "https://tgnzqtzbydztcfhqmxxh.supabase.co",
      "logo": "https://tgnzqtzbydztcfhqmxxh.supabase.co/logo.png",
      "image": "https://tgnzqtzbydztcfhqmxxh.supabase.co/images/resonow-hero.jpg",
      "foundingDate": "2023",
      "foundingLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "425 Washington Blvd",
          "addressLocality": "Jersey City",
          "addressRegion": "NJ",
          "postalCode": "07310",
          "addressCountry": "US"
        }
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "425 Washington Blvd",
        "addressLocality": "Jersey City",
        "addressRegion": "NJ",
        "postalCode": "07310",
        "addressCountry": "US"
      },
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "telephone": "+1-909-905-7788",
          "email": "info@resonow.org",
          "availableLanguage": ["en", "zh"]
        },
        {
          "@type": "ContactPoint",
          "contactType": "technical support",
          "email": "support@resonow.org",
          "availableLanguage": ["en", "zh"]
        }
      ],
      "sameAs": [
        "http://linkedin.com/company/resonow",
        "https://www.xiaohongshu.com/user/profile/63e3d3dd0000000027028c96"
      ],
      "knowsAbout": [
        isZh ? "能量疗愈" : "Energy Healing",
        isZh ? "心理咨询" : "Psychological Counseling", 
        isZh ? "传统中医" : "Traditional Chinese Medicine",
        isZh ? "瑜伽" : "Yoga",
        isZh ? "冥想" : "Meditation",
        isZh ? "芳香疗法" : "Aromatherapy",
        isZh ? "身心疗愈" : "Mind-Body Healing"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": isZh ? "疗愈服务" : "Healing Services",
        "itemListElement": [
          {
            "@type": "OfferCatalog",
            "name": isZh ? "能量疗愈" : "Energy Healing",
            "description": isZh ? "专业的能量疗愈服务" : "Professional energy healing services"
          },
          {
            "@type": "OfferCatalog", 
            "name": isZh ? "心理咨询" : "Psychological Counseling",
            "description": isZh ? "专业心理健康咨询服务" : "Professional mental health counseling services"
          },
          {
            "@type": "OfferCatalog",
            "name": isZh ? "传统中医" : "Traditional Chinese Medicine", 
            "description": isZh ? "传统中医疗法和诊断" : "Traditional Chinese medicine treatments and diagnosis"
          }
        ]
      },
      "makesOffer": {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": isZh ? "专业疗愈服务预约" : "Professional Healing Service Booking",
          "description": isZh ? "在线预约专业认证的疗愈师" : "Online booking with certified professional healers"
        },
        "availability": "https://schema.org/InStock",
        "areaServed": {
          "@type": "Place",
          "name": isZh ? "全球" : "Global"
        },
        "availableLanguage": ["en", "zh"]
      }
    };

    // Add the structured data to the page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-organization-structured-data', 'true');
    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const scriptToRemove = document.querySelector('script[data-organization-structured-data="true"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [i18n.language]);

  return null;
};